<div class="idle-timeout-warning">
    <span class="message" translate="idle.timeout-warning.message"></span>
     <span class="countdown">{{ data.countdown }}</span>
     <span class="seconds" [translate]="'idle.timeout-warning.' + (data.countdown > 1 ? 'seconds': 'second')"></span>.
</div>